/**
 * Created by Alex Aguilar on 4/27/2016.
 */
(function (angular) {
    'use strict';

    var metisMenuDirective = function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                $timeout(function () {
                    element.metisMenu({
                        activeClass: 'active',
                        preventDefault: false,
                        onTransitionStart: function(){
                            $('.sub-title-final').on('click',  function(){
                                var element = $(this),
                                    liParent = element.parent();

                                $('.sub-title-final').removeClass('title-active');
                                element.addClass('title-active');
                                $('.sub-title-active').removeClass('sub-title-active');
                                liParent.addClass('sub-title-active');
                            });
                        },
                        onTransitionEnd: function(){
                        }
                    });
                }, 1000);
            }
        };
    };

    var expandCollapseMenu = function (){
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                element.on("click", function(){
                    var element = $(this),
                        wrapper = $("#wrapper"),
                        arrow = $("#arrow");
                    var elementClosest = element.closest('#wrapper');
                    if(element.data("bars") == "expand"){
                        /*element.data("bars", "collapse");
                        wrapper.removeClass("wrapper-active");
                        wrapper.removeClass("sidebar-short-menu");
                        wrapper.addClass("sidebar-large-menu");
                        arrow.removeClass('fa-arrow-circle-right');
                        arrow.addClass('fa-arrow-circle-left');
                        arrow.data('menu', 'show');*/

                        element.data("bars", "collapse");
                        wrapper.removeClass("sidebar-large-menu");
                        wrapper.addClass("sidebar-short-menu");
                    }else{
                        /*element.data("bars", "expand");
                        wrapper.addClass("wrapper-active");*/

                        element.data("bars", "expand");
                        wrapper.removeClass("sidebar-short-menu")
                        wrapper.addClass("sidebar-large-menu");
                    }
                });
            }
        };
    }

    var longSmallMenu = function(){
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                var elementJQuery = element.find('span')
                var elementClosest = element.closest('#wrapper');
                var config = {
                    'classIconLarge': 'fa-arrow-circle-left',
                    'classIconShort': 'fa-arrow-circle-right',
                    'classLarge': 'sidebar-large-menu',
                    'classShort': 'sidebar-short-menu'
                };

                var largeShortIcon = function(element, type, iconHide, iconShow){
                    element.removeClass(iconHide);
                    element.addClass(iconShow);
                    element.data('menu', type);
                };

                var largeShortClass = function(removeClass, addClass){
                    elementClosest.removeClass(removeClass);
                    elementClosest.addClass(addClass);
                }

                elementJQuery.on('click',  function(){
                    var spanJQuery = $(this);
                    switch (spanJQuery.data('menu')){
                        case 'show':
                            largeShortIcon(spanJQuery, 'hide', config.classIconLarge, config.classIconShort);
                            largeShortClass(config.classLarge, config.classShort);
                            break;
                        case 'hide':
                            largeShortIcon(spanJQuery, 'show', config.classIconShort, config.classIconLarge);
                            largeShortClass(config.classShort, config.classLarge);
                            break;
                    }
                });
            }
        };
    }

    angular.module('aacMetisMenu', []).directive('aacMetisMenu', ['$timeout', metisMenuDirective]);
    angular.module('expandCollapseMenu', []).directive('expandCollapse', [expandCollapseMenu]);
    angular.module('longSmallMenu', []).directive('longSmallMenu', [longSmallMenu]);
})(angular);
